import React from "react";
import { Button, DataTableItem, DataTableRow } from "../../../../components/Component";

const ReadOnlyTableRow = ({ item, row_type, size, textClassname, item_id, setViewModal, setSelectedDataID, setSelectedData, icon_click_action, action_function }) => {
  return (
    <>
      {row_type === "first_col" ? (
        <>
          <DataTableRow className={`${textClassname ? textClassname : "text-primary"}`}>{item}</DataTableRow>
        </>
      ) : row_type === "normal_col" ? (
        <>
          <DataTableRow size={size ? size : "md"}>
            <span className={`tb-lead-sub text-${textClassname}`}>{item}</span>
          </DataTableRow>
        </>
      ) : row_type === "icon_col" ? (
        <>
          <DataTableRow size={size ? size : "md"}>
            <span className={`tb-lead-sub text-${textClassname}`}
              onClick={() => {
                setSelectedData(icon_click_action);
              }}>
              {item}
            </span>
          </DataTableRow>
        </>
      ) : row_type === "view_col" ? (
        <>
          <DataTableRow className="nk-tb-col-tools">
            <Button
              className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
              href="#view"
              onClick={(ev) => {
                ev.preventDefault();
                setSelectedDataID(item_id);
                setViewModal(true);
              }}
            >
              <span>View</span>
            </Button>
          </DataTableRow>
        </>
      ) : row_type === "view_det_link" ? (
        <>
          <DataTableRow className="nk-tb-col-tools">
            <Button
              className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
              href="#view"
              onClick={(ev) => {
              }}
            >
              <span>View Details</span>
            </Button>
          </DataTableRow>
        </>
      ) : row_type === "action_col" ? (
        <>
          <DataTableRow className="nk-tb-col-tools">
            <Button
              className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
              href="#view"
              onClick={(ev) => {
                ev.preventDefault();
                action_function(item_id);
              }}
            >
              <span>{item}</span>
            </Button>
          </DataTableRow>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ReadOnlyTableRow;
